module.exports = __webpack_public_path__ + "static/media/app-icon.8c3af547.png";